import React, {useState, useEffect} from 'react'
import * as style from './ContentFooter.module.css'
import { trackingEventCallAPI } from '../../../../api/trackingSDK'
import { EventTrackingList } from '../../../../api/const'
import { openAppZalo, openUniversalLink,openDeeplink } from  '../../../CommonFunction'
import {isIOS} from "react-device-detect";

const ContentFooter = ({ bindingInfo, sessionTracking, isAB }) => {
    const [timeCountDown, setTimeCountDown] = useState(6)
    const [checkClickButton, setCheckClickButton] = useState(false)

    const handleEventTrackingClickOpenApp = (eventName) => {
        let event = isAB ? 'AB'+eventName : eventName;
        const eventId = EventTrackingList.specialLandingPage.eventId[event];
        console.log('eventId', eventId)
        const metaData = {
            binding_token: bindingInfo?.binding_token,
            user_agent: navigator.userAgent,
            app_id: bindingInfo?.app_id
        }
        trackingEventCallAPI(eventId, sessionTracking, metaData)
    }

    useEffect(() => {
        if (!timeCountDown) {
            if (checkClickButton === false) {
                handleEventTrackingClickOpenApp('autoRedirectApp');
                openAppZalo(bindingInfo);
                setTimeout(() => {
                    handleEventTrackingClickOpenApp('timeoutRedirectToZPI');
                }, 2000)
            }
            return;
        }
        const intervalId = window.setInterval(() => {
            setTimeCountDown(timeCountDown - 1);
        }, 1000);
        return () => window.clearInterval(intervalId);
    }, [timeCountDown])

    const handleOpenZaloPayApp = () => {
        handleEventTrackingClickOpenApp('clickButtonOpenZaloPayApp');
        if(isIOS) {
            openUniversalLink(bindingInfo, null, 'app')
        }else {
            openDeeplink(bindingInfo, null, 'app')
        }

        setCheckClickButton(true)
    }

    const handleOpenZaloApp = () => {
        handleEventTrackingClickOpenApp('clickButtonOpenApp');
        openAppZalo(bindingInfo);
        setCheckClickButton(true)
    }

    let content = (
        <footer id={style.footerMiddleSpecial}>
            {timeCountDown > 0 && timeCountDown <= 3 &&
                <p> Hệ thống sẽ tự động điều hướng sau <span>{timeCountDown}</span> giây </p>
            }
            {timeCountDown <= 0 &&
                <p> Bạn đợi tí nhé...</p>
            }
            <button onClick={handleOpenZaloPayApp} className={style.primary}>
                <img className={style.zalopayImg} src="/img/zlp-logo-new.svg" alt="ZaloPay" />Mở Zalopay để liên kết
            </button>
            <button onClick={handleOpenZaloApp} className={style.secondary}>
                <img className="img-zalo" src="/img/logo-zalo.svg" alt="zalo" />Mở Zalo để liên kết
            </button>
        </footer>
    );
    return (
        content
    )
}

export default ContentFooter;
